import axiosInstance from '../Api/axiosInstance';

// Create Sender
export const createSender = (data, companyId) =>
	axiosInstance.post('/senders', data, { params: { companyId } });

// Get All Senders for a Company
export const getSenders = (companyId) =>
	axiosInstance.get('/senders', { params: { companyId } });

// Get Sender by ID
export const getSenderById = (id, companyId) =>
	axiosInstance.get(`/senders/${id}`, { params: { companyId } });

// Update Sender
export const updateSender = (id, data, companyId) =>
	axiosInstance.put(`/senders/${id}`, data, { params: { companyId } });

// Delete Sender
export const deleteSender = (id, companyId) =>
	axiosInstance.delete(`/senders/${id}`, { params: { companyId } });
